import request from '../api';
import { MATRIZID } from '../constants';

const STORAGE_KEY = 'restaurante';

export function getRestauranteFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    console.warn('Erro ao ler restaurante do storage', e);
    return null;
  }
}

export function getRestauranteIdSync() {
  const r = getRestauranteFromStorage();
  if (!r) return null;
  return r.ID || r.id || r.Id || r.restauranteId || null;
}

export async function ensureRestauranteLoaded() {
  const stored = getRestauranteFromStorage();
  if (stored) return stored;

  try {
    // Busca restaurantes da matriz e retorna o primeiro
    const { data } = await request.get(`/restaurante/get-all?matrizId=${MATRIZID}`);
    const first = Array.isArray(data) && data.length ? data[0] : null;
    if (first) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(first));
    }
    return first;
  } catch (e) {
    console.error('Erro ao buscar restaurantes da matriz', e);
    return null;
  }
}

export async function getMatrizRestaurants() {
  try {
    const { data } = await request.get(`/restaurante/get-all?matrizId=${MATRIZID}`);
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('Erro ao buscar restaurantes da matriz', e);
    return [];
  }
}

export function setSelectedRestaurante(rest) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rest));
  } catch (e) {
    console.warn('Erro ao salvar restaurante selecionado', e);
  }
}
